// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ArrowUp_arrow__M2heN","arrowActive":"ArrowUp_arrowActive__X7wZ0"};